<template>
  <div class="investigation-tab-form">
    <gc-form
      :formOptions="formOptions"
      :formItems="formItems"
      :isNormal="true"
      :data-model="investigation"
      :formMode="isReadOnly ? 'review' : 'edit'"
      :scrollingEnabled="false"
    />
  </div>
</template>

<script>
export default {
  props: {
    investigation: {
      type: Object,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formOptions: {
        gcLabelLocation: "left",
      },
    };
  },
  computed: {
    formItems() {
      var self = this;
      return [
        {
          itemType: "group",
          colCount: 1,
          cssClass: "investigation-form-group",
          items: [
            {
              dataField: "InvestigationNotes",
              label: { text: "Investigation Notes" },
              editorType: "dxTextArea",
              cssClass: "textarea-item",
              editorOptions: {
                placeholder: "Enter investigation notes...",
                disabled: self.isReadOnly,
                maxLength: 1000,
              },
            },
            {
              screenField: "ComplaintRootCause",
              dataField: "RootCauseClassificationCode",
              label: { text: "Root Cause Classification" },
              displayExpr: function (item) {
                return item ? item.Code + " - " + item.Description : "";
              },
              valueExpr: "Code",
              searchExpr: ["Code", "Description"],
              editorOptions: {
                disabled: self.isReadOnly,
                placeholder: "Select root cause...",
                showClearButton: true,
                onValueChanged: function (e) {
                  self.$emit("root-cause-changed", e.value);
                },
              },
            },
            {
              dataField: "RootCauseMethodology",
              label: { text: "Root Cause Methodology" },
              editorType: "dxTextArea",
              cssClass: "textarea-item",
              editorOptions: {
                placeholder: "Describe the root cause methodology and classification notes...",
                disabled: self.isReadOnly,
                maxLength: 1000,
              },
            },
          ],
        },
      ];
    },
  },
};
</script>

<style lang="scss">
.investigation-tab-form {
  .investigation-form-group {
    .dx-field-item-label-text {
      min-width: 200px;
    }
  }

  .textarea-item {
    .dx-field-item-label {
      vertical-align: top;
      padding-top: 7px;
    }
  }
}
</style>
